<!-- hauptcontent -->
@if (termin) {
  <div role="presentation">
    <now-wbsuche-lib-detail-tabbar [(currentTab)]="currentTab"></now-wbsuche-lib-detail-tabbar>

    <!-- Block und Tabbar Informationen -->
    @if (currentTab === 'Informationen') {
      <now-wbsuche-lib-tab-informationen [termin]="termin"></now-wbsuche-lib-tab-informationen>
    }

    <!-- Block und Tabbar Daten und Fakten -->
    @if (currentTab === 'Daten und Fakten') {
      <now-wbsuche-lib-tab-daten-fakten [termin]="termin"></now-wbsuche-lib-tab-daten-fakten>
    }

    <!-- Block und Tabbar - Anbieter -->
    @if (currentTab === 'Anbieter') {
      <now-wbsuche-lib-tab-anbieter [termin]="termin"></now-wbsuche-lib-tab-anbieter>
    }

    <hr />

    <div class="row p-2">
      <!-- Block Veröffentlichung/Datenherkunft. - Die Daten werden unter jeder Tabbar angezeigt -->
      <div class="col-12 col-lg-6 col-print-12 mb-3">
        <h2 class="h5 mt-0 mb-2">
          <i class="now-icon now-icon-info" aria-hidden="true"></i>
          <div class="ms-2">Veröffentlichungsinfos</div>
        </h2>
        <section class="detail-section d-block" id="veroeffentlichung">
          <now-wbsuche-lib-veroeffentlichungsinformationen
            [termin]="termin"
          ></now-wbsuche-lib-veroeffentlichungsinformationen>
          <hr class="d-none d-print-block" />
        </section>
      </div>

      <!-- Block Veröffentlichung/Datenherkunft. - Die Daten werden unter jeder Tabbar angezeigt -->
      <div class="col-12 col-lg-6 col-print-12 mb-3">
        <h2 class="h5 mt-0 mb-2">
          <i class="now-icon now-icon-folder" aria-hidden="true"></i>
          <div class="ms-2">Datenherkunft</div>
        </h2>
        <section class="detail-section d-block" id="datenherkunft">
          <ul class="p-0">
            <li class="d-flex flex-column mb-1">
              @if (termin.quelle && termin.quelle.portalLogo) {
                <img
                  id="datenherkunft_logo"
                  alt="Logo von {{ termin.quelle.id }}"
                  class="logo-marginalspalte d-print-none"
                  [ngSrc]="termin.quelle.portalLogo"
                  width="170"
                  height="42"
                />
                <span class="fw-bold">Name</span>
                <span id="datenherkunft_name">{{ mapPartnerIdZuName(termin.quelle.id) }}</span>
              } @else {
                <img
                  id="datenherkunft_logo_default"
                  alt="Logo von KURSNET"
                  class="logo-marginalspalte d-print-none"
                  ngSrc="./assets/images/logo-kursnet.png"
                  width="170"
                  height="42"
                />
                <span class="fw-bold">Name</span>
                <span id="datenherkunft_name_default">KURSNET</span>
              }
            </li>

            @if (termin.quelle && termin.quelle.portalLogo) {
              <li class="d-flex flex-column mb-1">
                <span class="fw-bold">Internet</span>
                <a
                  id="datenherkunft_link"
                  [attr.href]="termin.quelle.portalLink"
                  class="now-link-primary now-icon now-icon-arrow-square-out"
                >
                  {{ termin.quelle.portalLink }}
                </a>
              </li>
            }
            <hr class="d-none d-print-block" />
          </ul>
        </section>
      </div>
    </div>
  </div>
}
